module.exports = __webpack_public_path__ + "static/media/canaanite_text_01.91f0586b.jpg";